import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useUserQuery from '../hooks/useUserQuery';
import UserForm from '../components/UserForm/UserForm';
import getFormTitle from '#/common/utils/getFormTitle';

export interface UserParams {
  readonly id?: string;
}

const UserPage: React.FC = () => {
  const { id } = useParams() as UserParams;
  const userQuery = useUserQuery(id);
  const user = userQuery.data?.getUser?.data;

  // Use a ref to store the initial updatedAt value to prevent form remount
  // on background refetches (cache-and-network).
  const formKeyRef = useRef<string | null>(null);
  if (user && !formKeyRef.current) {
    formKeyRef.current = user.updatedAt ?? user.id ?? null;
  }

  const name = user?.name;
  const title = getFormTitle(id, name, 'User');
  return (
    <SubPage title={title} isLoading={userQuery.loading} showGoBackButton type="form">
      <UserForm key={`user-${id}-${formKeyRef.current}`} title={title} user={user || {}} />
    </SubPage>
  );
};

export default React.memo(UserPage);
